// assets/js/archiveComponent.js
import { Dropdown, Tooltip } from 'bootstrap';
export default function initArchiveComponent() {
    // Supporta più componenti nella stessa pagina
    document.querySelectorAll('[data-fsr-archive]').forEach((root) => {
        const cfg = {
            key: root.dataset.key,                 // es. "publication"
            baseUrl: root.dataset.baseUrl || window.location.pathname, // es. "/publications/"
            postType: root.dataset.postType || 'any',
            ajaxUrl: FSR_AJAX.ajax,          // localizzato da PHP
            nonce: FSR_AJAX.nonce,              // localizzato da PHP
        };

        const els = {
            form:      root.querySelector('[data-fsr-form]'),
            select:    root.querySelectorAll('[data-fsr-form] select'),
            search:    root.querySelector('[data-fsr-form] [data-fsr-search]'),
            posts:     root.querySelector('[data-fsr-posts]'),
            pills:     root.querySelector('[data-fsr-pills]'),
            pagination:root.querySelector('[data-fsr-pagination]'),
        };

        // ==========================================================
        // funzione utility per reinizializzare i tooltip Bootstrap
        // ==========================================================
        const initTooltips = () => {
            // Distruggi eventuali istanze esistenti per evitare duplicati
            document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
                if (el._tooltip) {
                    el._tooltip.dispose();
                }
                el._tooltip = new Tooltip(el);
            });
        };

        // --- State helpers ---
        const parseStateFromURL = () => {
            const url = new URL(window.location.href);
            const state = Object.fromEntries(url.searchParams.entries());
            // paged dal pathname /page/N/
            const m = url.pathname.match(/\/page\/(\d+)\//);
            state.paged = m ? parseInt(m[1], 10) : 1;
            return state;
        };

        const collectStateFromForm = () => {
            const fd = new FormData(els.form);
            const obj = {};
            for (const [k, v] of fd.entries()) {
                if (v !== '') obj[k] = v;
            }
            // paged se presente in data attribute (set da pagination click)
            if (root.dataset.paged) obj.paged = parseInt(root.dataset.paged, 10);
            //commento dava noia in caso di inserimento in pagine generiche
            //obj.post_type = cfg.postType;
            obj.archive_key = cfg.key;
            return obj;
        };

        const buildURLFromState = (state) => {
            const url = new URL(cfg.baseUrl, window.location.origin);
            const paged = state.paged && state.paged > 1 ? state.paged : null;
            if (!url.pathname.endsWith('/')) url.pathname += '/';
            if (paged) url.pathname += `page/${paged}/`;
            const qs = new URLSearchParams();
            Object.keys(state).forEach((k) => {
                if (!['paged'].includes(k) && state[k] !== '' && state[k] != null) qs.set(k, state[k]);
            });
            url.search = qs.toString();
            return url.toString();
        };

        const stateToFormData = (state) => {
            const fd = new FormData();
            fd.set('action', 'fsr_archive_fetch');
            fd.set('nonce', cfg.nonce);
            fd.set('archive_key', cfg.key);
            //fd.set('post_type', cfg.postType);
            fd.set('base_url', cfg.baseUrl);
            fd.set('context_tax', root.dataset.contextTax || '');
            fd.set('context_term', root.dataset.contextTerm || '');
            if (state.paged) fd.set('paged', state.paged);
            Object.keys(state).forEach((k) => {
                if (!['paged', 'post_type'].includes(k) && state[k] !== '' && state[k] != null) fd.set(k, state[k]);
            });
            return fd;
        };

        // --- Render helpers ---
        const renderPayload = (data, urlToPush=null) => {
            if (els.posts && data.posts_html !== undefined)      els.posts.innerHTML = data.posts_html;
            if (els.pagination && data.pagination_html !== undefined) els.pagination.innerHTML = data.pagination_html;
            if (els.pills && data.pills_html !== undefined)      els.pills.innerHTML = data.pills_html;
            if (urlToPush) window.history.pushState({fsr:true}, '', urlToPush);
            // clear paged flag used temporarily
            delete root.dataset.paged;
        };

        const showSkeleton = () => {
            if (!els.posts) return;

            // Conta quante card ci sono già (per dare una transizione fluida)
            const currentCards = els.posts.querySelectorAll('.Card__Horiz, .fsr-card').length;
            const numSkeletons = currentCards > 0 ? currentCards : 8;

            // Skeleton HTML minimal e accessibile
            const skeletonHTML = Array.from({ length: numSkeletons })
                .map(() => `
                      <div class="col-12 col-lg-6 mb-4">
                        <div class="Card__Horiz Card__Horiz__Default p-4">
                          <p class="card-text placeholder-glow w-100 py-4 px-4">
                              <span class="placeholder placeholder-lg col-7"></span>
                              <span class="placeholder placeholder-lg col-4"></span>
                
                              <span class="placeholder placeholder-lg col-4"></span>
                              <span class="placeholder placeholder-lg col-6"></span>
                
                              <span class="placeholder placeholder-lg col-8"></span>
                              <span class="placeholder placeholder-lg col-4"></span>
                         </p>
                        </div>
                      </div>
                    `)
                .join('');

            els.posts.innerHTML = `<div class="row" aria-busy="true" aria-live="polite">${skeletonHTML}</div>`;
        };

        // --- Core fetch ---
        let controller;

        const fetchAndRender = (state, pushUrl = true) => {
            // 🧩 Cancella eventuale richiesta precedente
            if (controller) controller.abort();
            controller = new AbortController();

            // 🦴 Mostra skeleton immediatamente
            showSkeleton();

            const fd = stateToFormData(state);
            const url = buildURLFromState(state);

            fetch(cfg.ajaxUrl, {
                method: 'POST',
                body: fd,
                credentials: 'same-origin',
                signal: controller.signal,
            })
                .then((r) => {
                    if (!r.ok) throw new Error(`HTTP ${r.status}`);
                    return r.json();
                })
                .then((resp) => {
                    if (resp.success && resp.data) {
                        // ⚡ Mostra prima i post (per reattività immediata)
                        if (els.posts && resp.data.posts_html !== undefined) {
                            els.posts.innerHTML = resp.data.posts_html;
                        }

                        initTooltips();

                        // Poi pills (filtri attivi)
                        if (els.pills && resp.data.pills_html !== undefined) {
                            els.pills.innerHTML = resp.data.pills_html;
                        }

                        // Poi paginazione con un piccolo delay per effetto “smooth”
                        setTimeout(() => {
                            if (els.pagination && resp.data.pagination_html !== undefined) {
                                els.pagination.innerHTML = resp.data.pagination_html;
                            }

                            // Aggiorna l’URL nel browser solo dopo che tutto è pronto
                            if (pushUrl) {
                                window.history.pushState({ fsr: true }, '', url);
                            }
                        }, 150);
                    } else {
                        // Fallback se non arrivano dati
                        if (els.posts) els.posts.innerHTML = '<p>No results found.</p>';
                        if (pushUrl) window.history.pushState({ fsr: true }, '', url);
                    }
                })
                .catch((err) => {
                    // Ignora errori di abort (utente che cambia filtro rapidamente)
                    if (err.name === 'AbortError') return;
                    console.error('AJAX Error:', err);
                    if (els.posts) els.posts.innerHTML = '<p>Network error.</p>';
                });
        };

        initTooltips();

        // --- Events ---
        // Submit (search) + change (select)
        if (els.form) {
            let debounceTimer;

            // 🔹 helper debounce per evitare richieste multiple troppo ravvicinate
            const triggerFetch = () => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    const state = collectStateFromForm();
                    state.paged = 1;
                    fetchAndRender(state, true);
                }, 200);
            };

            // --- Submit (solo per ricerca testuale libera) ---
            els.form.addEventListener('submit', (e) => {
                e.preventDefault();

                // validazione autocomplete (come prima)
                let invalidAutocomplete = false;
                els.form.querySelectorAll('[data-autocomplete-real]').forEach((hiddenReal) => {
                    const dropdownMenu = hiddenReal.closest('.dropdown-menu');
                    const input = dropdownMenu.querySelector('[data-autocomplete]');
                    const wrapper = dropdownMenu.closest('.dropdown');
                    wrapper.classList.remove('is-invalid');
                    const oldFeedback = dropdownMenu.querySelector('.invalid-feedback');
                    if (oldFeedback) oldFeedback.classList.add('d-none');
                    if (input.value.trim() !== '' && hiddenReal.value.trim() === '') {
                        invalidAutocomplete = true;
                        wrapper.classList.add('is-invalid');
                        const fb = dropdownMenu.querySelector('.invalid-feedback');
                        if (fb) fb.classList.remove('d-none');
                    }
                });

                if (invalidAutocomplete) {
                    const firstInvalid = els.form.querySelector('.is-invalid [data-autocomplete]');
                    if (firstInvalid) firstInvalid.focus();
                    return;
                }

                // ricerca libera → invio manuale (Enter)
                triggerFetch();
            });

            // --- Select normali: submit automatico on change ---
            els.select.forEach((sel) => {
                sel.addEventListener('change', triggerFetch);
            });

            // --- Autocomplete: submit automatico dopo selezione valida ---
            els.form.querySelectorAll('[data-autocomplete]').forEach((input) => {
                input.addEventListener('change', () => {
                    const hiddenReal = els.form.querySelector(
                        `[data-autocomplete-real="${input.dataset.autocomplete}"]`
                    );
                    if (hiddenReal && hiddenReal.value.trim() !== '') {
                        triggerFetch();
                    }
                });
            });

            // --- Date interval filter (upcoming/past)
            const dateIntervalInput = els.form.querySelector('select[name="date_interval"]');
            if (dateIntervalInput) {
                dateIntervalInput.addEventListener('change', () => {
                    const state = collectStateFromForm();
                    state.paged = 1;
                    triggerFetch();
                });
            }
        }

        // Pills remove (delegation)
        root.addEventListener('click', (e) => {
            const pill = e.target.closest('[data-fsr-pill]');
            if (!pill) return;
            const name = pill.dataset.name;

            const input = els.form?.querySelector(`[name="${name}"]`);
            const inputReal = els.form?.querySelector(`[name="${name}_real"]`);
            if (!input) return;
            e.preventDefault();

            // reset valori
            input.value = '';
            if (inputReal) inputReal.value = '';

            const state = collectStateFromForm();
            delete state[name];
            delete state[name + '_real']; // ✅ FIX
            state.paged = 1;
            fetchAndRender(state, true);

            // ✅ trigger evento custom per resettare dropdown
            const event = new CustomEvent('fsr:filter:cleared', {
                detail: { name },
                bubbles: true,
                composed: true
            });
            root.dispatchEvent(event);
        });

        // Pagination click (delegation)
        root.addEventListener('click', (e) => {
            const a = e.target.closest('[data-fsr-page]');
            if (!a) return;
            e.preventDefault();
            const page = parseInt(a.dataset.fsrPage, 10);
            root.dataset.paged = page; // temporary, so collectStateFromForm includes it
            const state = collectStateFromForm();
            state.paged = page;
            fetchAndRender(state, true);
        });

        // Back/Forward support
        window.addEventListener('popstate', (e) => {
            const state = parseStateFromURL();
            fetchAndRender(state, false);
        });

        // --- First boot: unisci stato del form (hidden inclusi) + URL (deep-link)
        const formState = collectStateFromForm();     // prende anche <input type="hidden" name="post_tag" ...>
        const urlState  = parseStateFromURL();        // prende paged e querystring
        const initState = { ...formState, ...urlState }; // l'URL sovrascrive il form se presente
        // --- Default automatico: upcoming events
        if (
            els.form.querySelector('select[name="date_interval"]') &&
            !initState.date_interval
        ) {
            initState.date_interval = 'upcoming';
        }
        fetchAndRender(initState, false);


        // --- AUTOCOMPLETE CHECKBOX DROPDOWN (single select) ---
        root.querySelectorAll('[data-autocomplete]').forEach(input => {
            const source         = input.dataset.autocomplete;
            const dropdownMenu   = input.closest('.dropdown-menu');
            const listBox        = dropdownMenu.querySelector('[data-autocomplete-list]');
            const fb             = dropdownMenu.querySelector('[data-autocomplete-feedback]');
            const hiddenFriendly = dropdownMenu.querySelector(`[data-autocomplete-friendly="${source}"]`);
            const hiddenReal     = dropdownMenu.querySelector(`[data-autocomplete-real="${source}"]`);
            const dropdownRoot   = input.closest('.dropdown');
            const ddToggle       = dropdownRoot.querySelector('[data-bs-toggle="dropdown"]');

            // 🔹 Identifica la chiave filtro (es. author, editor, ecc.)
            const filterKey = (
                (hiddenReal && hiddenReal.name) ||
                (hiddenFriendly && hiddenFriendly.name) ||
                ''
            ).replace(/_real$/, '') || source;

            let allOptions = [];

            function showError(show) {
                if (!fb) return;
                fb.classList.toggle('d-none', !show);
                input.classList.toggle('is-invalid', show);
            }

            function renderList(options) {
                listBox.textContent = '';
                const fragment = document.createDocumentFragment();

                options.forEach((item) => {
                    const value = String(item?.value ?? '');
                    const labelText = String(item?.label ?? '');

                    const label = document.createElement('label');
                    label.className = 'custom-square-checkbox mb-2 d-block';

                    const checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.value = value;
                    checkbox.dataset.label = labelText;

                    const icon = document.createElement('span');

                    label.appendChild(checkbox);
                    label.appendChild(icon);
                    label.appendChild(document.createTextNode(` ${labelText}`));
                    fragment.appendChild(label);
                });

                listBox.appendChild(fragment);

                // bind selezione singola
                listBox.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                    if (hiddenReal.value && cb.value === hiddenReal.value) cb.checked = true;
                    cb.addEventListener('click', () => {
                        // deseleziona altri
                        listBox.querySelectorAll('input[type="checkbox"]').forEach(other => {
                            if (other !== cb) other.checked = false;
                        });

                        if (cb.checked) {
                            input.value = cb.dataset.label;
                            hiddenFriendly.value = cb.dataset.label;
                            hiddenReal.value     = cb.value;

                            const btnLabel = dropdownRoot.querySelector('.btn.dropdown-toggle span.me-4');
                            if (btnLabel) {
                                btnLabel.textContent = cb.dataset.label;
                            }

                            showError(false);
                            Dropdown.getOrCreateInstance(ddToggle).hide();
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        } else {
                            resetDropdown();
                        }
                    });
                });
            }

            // 🔹 Carica i primi 10 risultati o l'autore selezionato
            function loadDefaultList() {
                const selectedReal = hiddenReal.value;
                const selectedFriendly = hiddenFriendly.value;

                fetch(`/wp-admin/admin-ajax.php?action=fsr_archive_suggestions&source=${encodeURIComponent(source)}&q=`)
                    .then(r => r.json())
                    .then(list => {
                        allOptions = Array.isArray(list) ? list : [];
                        if (selectedReal && selectedFriendly) {
                            renderList([{ label: selectedFriendly, value: selectedReal }]);
                        } else {
                            renderList(allOptions.slice(0, 10));
                        }
                    });
            }

            // 🔹 Ricerca interna live
            input.addEventListener('input', e => {
                const q = e.target.value.trim().toLowerCase();
                const filtered = q
                    ? allOptions.filter(a => a.label.toLowerCase().includes(q))
                    : allOptions.slice(0, 10);
                renderList(filtered);
                hiddenFriendly.value = '';
                hiddenReal.value = '';
            });

            // 🔹 Apri dropdown → carica lista
            ddToggle.addEventListener('click', loadDefaultList);

            // 🔹 Reset completo (riutilizzato in più punti)
            function resetDropdown() {
                input.value = '';
                hiddenFriendly.value = '';
                hiddenReal.value = '';

                const btnLabel = dropdownRoot.querySelector('.btn.dropdown-toggle span.me-4');
                if (btnLabel) {
                    btnLabel.textContent = 'Author';
                }

                listBox.innerHTML = '';
                fetch(`/wp-admin/admin-ajax.php?action=fsr_archive_suggestions&source=${encodeURIComponent(source)}&q=`)
                    .then(r => r.json())
                    .then(list => {
                        const allOptions = Array.isArray(list) ? list : [];
                        const defaultList = allOptions.slice(0, 10);
                        renderList(defaultList);
                    });
            }

            // 🔹 Ascolta la rimozione del filtro (pill X)
            root.addEventListener('fsr:filter:cleared', (e) => {
                if (e.detail.name !== filterKey) return;
                resetDropdown();
            });
        });


    });

}